export const scrollbarOptions = {
  speed: 1,
  damping: 0.2,
  thumbMinSize: 20,
  syncCallbacks: true,
  renderByPixels: true,
  alwaysShowTracks: false,
  continuousScrolling: true,
  overscrollEffect: 'bounce',
  overscrollDamping: 0.2
};
